export const isNextEnvironment = (): boolean => {
  const hostname = window.location.hostname;
  return hostname.includes('next') || hostname.includes('localhost');
};
